const API_PAGINATION_SIZE = 50;
export default API_PAGINATION_SIZE;